<ng-template #content>
  <section class="review-setup-dialog" aria-label="Review setup details">
    <section class="review-setup-dialog__changes" [attr.aria-labelledby]="idPrefix + '-changes'">
      <h3 [id]="idPrefix + '-changes'" tabindex="-1">Setup changes</h3>
      <ul><li *ngFor="let change of candidate()?.summary">{{ change }}</li></ul>
      <p class="review-setup-dialog__hint">This applies the setup to the working draft. Save draft persists it afterward.</p>
    </section>
    <section class="review-setup-dialog__paths" [attr.aria-labelledby]="idPrefix + '-paths'">
      <h3 [id]="idPrefix + '-paths'">Result paths</h3>
      <fieldset *ngFor="let row of rows(); let index = index; trackBy: trackOutcome" [attr.data-review-setup-result]="row.code" [disabled]="disabled()">
        <legend>{{ row.label }}</legend>
        <div class="review-setup-dialog__route-controls">
          <label>Movement
            <select uiControl #movementModel="ngModel" [attr.aria-label]="row.code + ' setup movement'" [ngModel]="row.movement"
              (ngModelChange)="changeMovement(row, $event, movementModel)">
              <option value="forward">Continue forward</option><option value="return">Return to earlier work</option>
            </select>
          </label>
          <label>{{ row.movement === 'return' ? 'Work step to revisit' : 'Destination' }}
            <select uiControl #destinationModel="ngModel" [attr.aria-label]="row.code + ' setup destination'" [ngModel]="row.destinationNodeId"
              [attr.aria-describedby]="rowIssue(row) ? idPrefix + '-issue-' + index : null"
              (ngModelChange)="changeDestination(row, $event, destinationModel)">
              <option value="" disabled>{{ row.movement === 'return' ? 'Choose a work step for this return' : 'Choose destination' }}</option>
              <option *ngIf="hasUnavailableDestination(row)" [value]="row.destinationNodeId" disabled>{{ row.savedUnavailable || 'Unavailable saved destination' }}</option>
              <option *ngFor="let choice of row.choices; trackBy: trackChoice" [value]="choice.id">{{ choice.label }}</option>
            </select>
          </label>
        </div>
        <p *ngIf="rowIssue(row) as issue" class="review-setup-dialog__hint" [id]="idPrefix + '-issue-' + index" role="status">{{ issue }}</p>
      </fieldset>
    </section>
    <p *ngIf="error()" class="review-setup-dialog__error" role="alert">{{ error() }}</p>
    <footer class="review-setup-dialog__actions">
      <button uiButton [wrap]="true" [text]="true" type="button" (click)="dismiss()">Cancel review setup</button>
      <button uiButton [wrap]="true" severity="primary" [outlined]="false" type="button" [disabled]="!applyAllowed()" (click)="apply()">{{ candidate()?.primaryLabel }}</button>
    </footer>
  </section>
</ng-template>
